import React, { useState } from 'react';

import { Banner, Box, Spinner, Text } from '@betterment/samba-react';
import { useFeatureFlag } from '@betterment/shared-components';
import { SectionLayout } from '@betterment/style-closet-react';

import IntegrationConnectList from './IntegrationConnectList';
import IntegrationsBanner from './IntegrationsBanner';

import { Notification } from '../../apps/FirmIntegrationsApp';
import NotFound from '../NotFound';
import { SettingsLayout } from '../Settings/SettingsLayout';

const SETTINGS_SPA_ENABLED = 'retail.b4a_settings_spa_q1_2026_enabled';

const FirmIntegrationsPage: React.FC = () => {
  const [notification, setNotification] = useState<Notification | null>(null);
  const { enabled, loading } = useFeatureFlag({ splitName: SETTINGS_SPA_ENABLED, context: 'FirmIntegrationsPage' });

  if (loading) {
    return (
      <Box css={{ display: 'flex', height: '100vh', alignItems: 'center', justifyContent: 'center' }}>
        <Spinner size="lg" />
      </Box>
    );
  }

  if (!enabled) {
    return <NotFound />;
  }

  return (
    <SettingsLayout activeTab="integrations">
      <SectionLayout>
        <SectionLayout.ContentWrapper>
          <IntegrationsBanner />
          {notification && (
            <Banner variant={notification.variant} css={{ mt: 'space.300', mb: 'space.0' }}>
              <Banner.Content>
                <Text as="p">{notification.message}</Text>
              </Banner.Content>
              <Banner.Close onClick={() => setNotification(null)} />
            </Banner>
          )}
          <React.Suspense
            fallback={
              <Box css={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'container.small' }}>
                <Spinner size="lg" />
              </Box>
            }
          >
            <IntegrationConnectList setNotification={setNotification} />
          </React.Suspense>
        </SectionLayout.ContentWrapper>
      </SectionLayout>
    </SettingsLayout>
  );
};

export default FirmIntegrationsPage;
